import { apiParamethor } from '@spo/services/api';
import { PostApiParamethorBody } from '@spo/types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { sleep } from '../utils/sleep';

export const useParameters = (
  postApiParamethorBody: PostApiParamethorBody,
  debounce = false,
) => {
  return useQuery({
    queryKey: ['useParameters', postApiParamethorBody],
    queryFn: async () => {
      if (debounce) {
        await sleep(800);
      }
      const response = await apiParamethor.getParameters(postApiParamethorBody);
      return response;
    },
    placeholderData: keepPreviousData,
    enabled: !!postApiParamethorBody.uid,
  });
};
